<template>
  <div :style="{'min-height':clientHeight+'px','background-color':'#F7F7F7','padding-bottom':'50px'}" id="outermost">

    <van-nav-bar
      title="添加问题跟进记录"
      left-text="返回"
      left-arrow
      @click-left="$router.back()"
      id="topbar"
    />
    <van-form @submit="onSubmit">
      <div style="padding:20px;">

        <div class="infoTit">添加记录</div>
        <div class="topDiv">
          <van-cell-group>
            <van-field label="跟进人" required readonly v-model="record.followUserName" input-align="right"
                       placeholder="点击选择跟进人"
                       :rules="[{ required: true, message: '请选择跟进人'}]"/>
          </van-cell-group>


          <span style="margin-left: 16px;font-size: 13px">跟进凭证：</span>
          <van-uploader v-model="signPhotos" :max-count="1" :before-delete="beforeDel" :before-read="beforeRead"
                        :after-read="afterRead" style="margin-left: 160px"/>

          <van-cell-group>
            <van-field label="跟进日期" required readonly v-model="record.followDate" input-align="right"
                       placeholder="点击选择跟进日期"
                       :rules="[{ required: true, message: '请选择跟进日期'}]"/>
          </van-cell-group>
          <van-cell-group>
            <van-field label="跟进记录" required type="textarea" maxlength="200" show-word-limit
                       v-model="record.followRecord" input-align="right" placeholder="点击输入跟进记录"
                       :rules="[{ required: true, message: '请输入跟进记录'}]"/>
          </van-cell-group>
        </div>

      </div>
      <div style="position: fixed;bottom: 0px;width: 100%;">
        <van-button block color="#1B75F6" native-type="submit">完成提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import $ from '@/fly'
import {Dialog, Toast} from 'vant';
import uploadfilecommon from '@/libs/uploadfilecommon';

export default {
  name: 'project-addProblemFollowRecord',
  data() {
    return {
      clientHeight: window.screen.height,
      record: {
        problemId: '',
        followUser: '',
        followUserName: '',
        followDate: '',
        followRecord: '',
        attId:''
      },
      signPhotosId: '',
      signPhotos: [],
    }
  },

  methods: {
    beforeDel(file, detail) {
      Dialog.confirm({
        title: '是否删除签到照片'
      }).then(() => {
        $.delete('deleteFile/' + this.signPhotosId).then(res => {
          Toast.success('删除成功！');
          this.signPhotosId = '';
          this.signPhotos.splice(detail.index, 1);
          return true;
        }).catch(err => {
          Toast.fail(err.message);
          return false;
        });
      })
    },
    beforeRead(file) {
      if (file.length > 1) {
        file.forEach(item => {
          if (item.type !== 'image/jpeg' && item.type !== 'image/png') {
            Toast('只允许上传jpg/png格式的图片！')
            return false;
          }
        })
      } else {
        if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
          Toast('只允许上传jpg/png格式的图片！')
          return false;
        }
      }
      return true
    },
    async afterRead(file) {
      // 此时可以自行将文件上传至服务器
      file.status = 'uploading';
      file.message = '上传中...';
      const fid = await uploadfilecommon(file.file, 'FOLLOW_CREDENTIALS')
      file.status = 'done';
      file.message = '上传成功';
      if (fid && fid.length === 32) {
        this.signPhotosId = fid;
      }
    },
    onSubmit() {
      this.record.attId = this.signPhotosId
      $.post('problemFollow', this.record).then(res => {
        Toast.success('添加成功！');
        this.$router.back();
      }).catch(err => {
        Toast.fail(err.message);
      })
    },
    // 获取当前年月日
    getCurrentDate() {
      const nowDate = new Date();
      const date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate()
      }
      const newmonth = date.month >= 10 ? date.month : '0' + date.month
      const day = date.date >= 10 ? date.date : '0' + date.date
      return date.year + '-' + newmonth + '-' + day
    }
  },
  mounted() {
    this.record.problemId = localStorage.getItem('problemId');
    this.record.followDate = this.getCurrentDate();
    this.record.followUser = this.$store.state.admin.user.info.userId;
    this.record.followUserName = this.$store.state.admin.user.info.nname;
  }
}
</script>

<style lang="less" scoped>
.topDiv {
  margin-top: 30px;
  padding: 20px;
  background-color: #FFFFFF;
}

.infoTit {
  color: #242E42;
  font-size: 30px;
  font-weight: bold;
}

</style>
